var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (allowedSandboxedFeatures, button, i18n) {
buf.push("<div class=\"full-screen content-fill hide-overflow\"><iframe type=\"text/html\" frameborder=\"0\"" + (jade.attr("sandbox", allowedSandboxedFeatures, true, false)) + " class=\"scorm-object\"></iframe><div class=\"exit-btn btn\">" + (jade.escape(null == (jade_interp = (button && button.text) || i18n("buttons.done")) ? "" : jade_interp)) + "</div></div>");}.call(this,"allowedSandboxedFeatures" in locals_for_with?locals_for_with.allowedSandboxedFeatures:typeof allowedSandboxedFeatures!=="undefined"?allowedSandboxedFeatures:undefined,"button" in locals_for_with?locals_for_with.button:typeof button!=="undefined"?button:undefined,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}